"use client";

import { useMatchMedia } from "./useMatchMedia";

// True only on devices with a fine pointer that supports hover (desktop
// trackpads/mice). Touch screens, stylus-only inputs, and most TVs return
// false. Returns `null` until first hydration so SSR/CSR agree.
export function useCanHover(): boolean | null {
  return useMatchMedia("(hover: hover) and (pointer: fine)");
}
